const db = {
    name:"Kodart Tətbiq və Təlim mərkəzi",
    logo:"1",
    courses:[
         {
            id:1,
            title:"kod-kəşfiyyatçısı",
            prefix:"Addım 1",
            name:"Kod Kəşfiyyatçısı",
            image:'/Images/Courses/kod-kəşfiyyatçısı.png',
            subheader:"test",
            description:"Proqramçı-Məktəbli təlim proqramının ilk mərhələsi olaraq nəzərdə tutulmuş təlimdə proqramlaşdırmanın təməlləri aşılanır. Qoşulmaq üçün məktəbli olmaqdan başqa heç bir ilkin şərt yoxdur. Dərs proqramını həm əyləncəli, həm də öyrədicidir. Məktəblilərə proqramlaşdırmanın çətin olmadığını öyrədərək göstəririk.",
            subjects:["Computer basics","Algorithms","Scratch","HTML","CSS", "Javascript"],
            duration:"4 ay",
            program:[
                {
                    order:"1",subject:"İlkin kompüter bilikləri", description:"",duration:""
                },
                {
                    order:"2",subject:"Scratch ilə Blok Proqramlaşdırma", description:"",duration:""
                },
                {
                    order:"3",subject:"Alqoritmlər", description:"",duration:""
                },
                {
                    order:"4",subject:"HTML, CSS, Javascript ilə Veb Proqramlaşdırmaya giriş", description:"",duration:""
                }
            ]
        },
         {
            id:1,
            title:"proqram-komandiri",
            prefix:"Addım 2",
            name:"Proqram Komandiri",
            image:'/Images/Courses/proqram-komandiri.png',
            subheader:"test",
            description:"Proqramlaşdırmanın və proqram təminatı üzrə təməl anlayışları mənimsəmiş məktəblilər burada proqramlaşdırmanın dərinliklərinə dalırlar və əyləncədən ayrılmasalar da azacıq uzaqlaşırlar. Bu təlimin iştirakçıları artıq proqramlaşdırma, informasiya texnologiyaları, data analitika sahəsində karyera qurmaqda qərarlıdırlar.",
            subjects:["Python","Data structures","Flask","SQL Basics"],
            duration:"4 ay",
            program:[
                {
                    order:"1",subject:"Python ilə OOP", description:"",duration:""
                },
                {
                    order:"2",subject:"Data strukturları", description:"",duration:""
                },
                {
                    order:"3",subject:"GitHub", description:"",duration:""
                },
                {
                    order:"4",subject:"Flask ilə Veb Proqramlaşdırma", description:"",duration:""
                },
                {
                    order:"5",subject:"SQL-ə giriş", description:"",duration:""
                }
            ]
        },
         {
            id:1,
            title:"data-admiral",
            prefix:"Addım 3",
            name:"Data Admiral",
            image:'/Images/Courses/data-admiral.png',
            subheader:"test",
            description:"Proqramçı-Məktəbli təliminin Data mərhələsi. Məktəbli artıq proqramlaşdırma dili bilir, proqram təminatının necə işlədiyi barədə biliklər əldə edib. Data Admiral təlimi ilə birgə o, müasir dövrdə datanın önəmi, onunla işləmə qaydası və istifadə istiqamətləri barədə geniş məlumatlar əldə edəcək. Əyləncə hələ bizimlədir. ",
            subjects:["Excel","PostgreSQL","Python","Data structures"],
            duration:"4 ay",
            program:[
                {
                    order:"1",subject:"Excel ilə Dataya giriş", description:"",duration:""
                },
                {
                    order:"2",subject:"SQL ilə əməliyyatlar", description:"",duration:""
                },
                {
                    order:"3",subject:"Data Analitika", description:"",duration:""
                },
                {
                    order:"4",subject:"Datanın Vizuallaşdırılması", description:"",duration:""
                }
            ]
        },
        {
            id:1,
            title:"webmaster",
            prefix:"Addım 4",
            name:"WebMaster",
            image:'/Images/Courses/webmaster.png',
            subheader:"test",
            description:"Məktəbli demək olar ki, artıq bütün əsas alətlərlə tanışdır. İndi o istiqamətləndirici təlimə nöqtə qoymalı və sərbəst inkişafa öz qədəmlərini atmalıdır. Bu mərhələdə bir veb layihəni 0-dan necə inkişaf etdirmək, yayımlamaq, idarə etmək və qorumaq olar; onu öyrənəcəyik!",
            subjects:["Domain","Hosting","Content Management", "SEO", "OWASP","Project Management"],
            duration:"4 ay",
            program:[
                {
                    order:"1",subject:"Layihə İdarəetməsinə giriş", description:"",duration:""
                },
                {
                    order:"2",subject:"Veb saytın yayımlanması", description:"",duration:""
                },
                {
                    order:"3",subject:"Məzmun idarəetməsi", description:"",duration:""
                },
                {
                    order:"4",subject:"Axtarış Optimizasiyası", description:"",duration:""
                },
                {
                    order:"5",subject:"Veb təhlükəsizliyinə giriş", description:"",duration:""
                }
            ]
        }
    ],
    solutions:[
        {title:"Veb saytlar",subtitle:"",description:"",order:"1",image:"./Images/Services/web.png",enabled:true},
        {title:"Xüsusi biznes həlləri",subtitle:"",description:"",order:"2",image:"./Images/Services/businesssolutions.webp",enabled:true},
        {title:"Konsaltinq",subtitle:"",description:"",order:"3",image:"./Images/Services/consulting.png",enabled:true}
    ],
    contacts:{
        phone:"050 992 00 10",
        phone_intl:"+994 50 992 0010",
        eMail:"info@kodart.az",
        linkedin:"https://linkedin.com/company/kodartaz",
        instagram:"https://instagram.com/kodart.az",
        facebook:"https://facebook.com/kodart.az",
        tiktok:"https://tiktok.com/@kodart.az",
        threads:"https://threads.net/@kodart.az",
        whatsappLink:"https://wa.link/g3nct3",
        address:"Xırdalan şəhəri, Məmməd Əmin Rəsulzadə küç., ev 3.",
        map:"https://maps.app.goo.gl/ZvQ3CuxNAvB9SdZj8",
        coordinates:{
            latitude:"42",
            longtitude:"45"
        }
    }
}

export default db;
